import { render, staticRenderFns } from "./IntegralDetails.vue?vue&type=template&id=184fd087&scoped=true&"
import script from "./IntegralDetails.vue?vue&type=script&lang=js&"
export * from "./IntegralDetails.vue?vue&type=script&lang=js&"
import style0 from "./IntegralDetails.vue?vue&type=style&index=0&id=184fd087&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184fd087",
  null
  
)

export default component.exports